import { take, takeLatest } from "redux-saga/effects";
import { Creators as AllCreators, Types as AllTypes } from "../../actions";
import { fetchUsersAnalyticsSummaryForClass } from "../../actions/analytics";
import { fetchClass } from "../../actions/classes";
import { fetchCourse } from "../../actions/courses";
import { exportAssessments } from "../../actions/export-assessments";
import { fetchAllUsersForClass } from "../../actions/users";

const Creators = (AllCreators as any).App.ClassAnalytics;
const Types = (AllTypes as any)._APP._CLASS_ANALYTICS;

export function* watchExportAssements() {
  yield takeLatest(Types.EXPORT_ASSESSMENTS, exportAssessments);
}

export function* watchFetchClassData() {
  yield takeLatest(
    Types.FETCH_CLASS_DATA,
    fetchClass({
      onFailure: Creators.handleFetchClassDataFailure,
      onSuccess: Creators.handleFetchClassDataSuccess,
    })
  );
}

export function* watchFetchCourseData() {
  yield takeLatest(
    Types.FETCH_COURSE_DATA,
    fetchCourse({
      onFailure: Creators.handleFetchCourseDataFailure,
      onSuccess: Creators.handleFetchCourseDataSuccess,
    })
  );
}

export function* watchFetchAllUsers() {
  yield takeLatest(
    Types.FETCH_ALL_USERS,
    fetchAllUsersForClass({
      onFailure: Creators.handleFetchAllUsersFailure,
      onSuccess: Creators.handleFetchAllUsersSuccess,
    })
  );
}

export function* watchFetchUsersAnalytics() {
  yield takeLatest(
    Types.FETCH_USERS_ANALYTICS,
    fetchUsersAnalyticsSummaryForClass({
      onFailure: Creators.handleFetchUsersAnalyticsFailure,
      onSuccess: Creators.handleFetchUsersAnalyticsSuccess,
    })
  );
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
